import * as React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Toolbar, Typography, Box, IconButton, Button, Avatar, Menu, MenuItem, useMediaQuery, useTheme, Stack } from '@mui/material';
import { LoginDialog } from '../../Authentication/Components/LoginDialog';
import { useIsAuthenticated, useLogout } from '../../Authentication/Hooks/AuthHooks';


export default function TopBar() {

    const [anchorElNav, setAnchorElNav] = React.useState<HTMLElement>();
    const [anchorElUser, setAnchorElUser] = React.useState<HTMLElement>();
    const [openLoginModal, setOpenLoginModal] = React.useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const isAuthenticated = useIsAuthenticated();
    const logout = useLogout();


    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleOpenLoginModal = () => {
        setOpenLoginModal(true);
    }


    const handleCloseMenu = () => {
        setAnchorElUser(undefined);
        setAnchorElNav(undefined);
    };

    const handleLogout = () => {
        logout();
        handleCloseMenu();
    }

    const navRoutes = [
        { name: "Home", route: "/" },
        { name: "Minesweeper", route: "/games/minesweeper" },
        { name: "Mastermind", route: "/games/mastermind" },
        { name: "Shopping", route: "/shopping" },
    ]


    return (
        <AppBar position="relative" >
            <Toolbar >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignContent="center"
                    sx={{ flexGrow: 1 }}
                >
                    {isMobile && (
                        <IconButton onClick={handleOpenNavMenu}>
                            <MenuIcon />
                        </IconButton>

                    )}
                    <Menu
                        anchorEl={anchorElNav}
                        open={!!anchorElNav}
                        onClose={handleCloseMenu}
                    >
                        {navRoutes.map((route) => (
                            <MenuItem
                                key={route.name}
                                href={route.route}
                                component="a"
                            >
                                <Typography>{route.name}</Typography>
                            </MenuItem>
                        ))}
                    </Menu>

                    <Typography variant="h6" >
                        Shavahar
                    </Typography>

                    {!isMobile && (
                        <Box>
                            {navRoutes.map((route) => (
                                <Button color={"inherit"} key={route.name} href={route.route}>
                                    <Typography>{route.name}</Typography>
                                </Button>
                            ))}

                        </Box>
                    )}

                    <Box>
                        {isAuthenticated ? (
                            <IconButton onClick={handleOpenUserMenu}>
                                <Avatar />
                            </IconButton>
                        ) : (

                            <IconButton onClick={handleOpenLoginModal}>
                                <PersonIcon />
                            </IconButton>

                        )}
                        <Menu
                            anchorEl={anchorElUser}
                            open={!!anchorElUser}
                            onClose={handleCloseMenu}
                        >
                            <MenuItem onClick={handleLogout}>
                                <Typography>Logout</Typography>
                            </MenuItem>
                        </Menu>
                        <LoginDialog open={openLoginModal} onClose={() => setOpenLoginModal(false)} />

                    </Box>
                </Stack>
            </Toolbar>
        </AppBar>
    );
}